import './lib/recovery'; // capture invite/recovery URL BEFORE the Supabase client loads
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { i18n } from './i18n';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { OrgProvider } from './lib/org';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <OrgProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </OrgProvider>
      </AuthProvider>
    </I18nextProvider>
  </StrictMode>,
);
